// Generated by purs version 0.14.4
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
var withDynamic_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dyn) {
            return function (widget) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (slot) {
                    return Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(function (x) {
                        return Control_Monad_Replace.replaceSlot(slot)(widget(x));
                    })(dyn);
                });
            };
        };
    };
};
var weakDynamic_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dyn) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (slot) {
                return Specular_FRP_WeakDynamic.subscribeWeakDyn_(dictMonadFRP)(Control_Monad_Replace.replaceSlot(slot))(dyn);
            });
        };
    };
};
var weakDynamic = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dyn) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (slot) {
                return Specular_FRP_WeakDynamic.subscribeWeakDyn(dictMonadFRP)(Control_Monad_Replace.replaceSlot(slot))(dyn);
            });
        };
    };
};
var dynamic_ = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dyn) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (slot) {
                return Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(Control_Monad_Replace.replaceSlot(slot))(dyn);
            });
        };
    };
};
var unlessD = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dyn) {
            return function (block) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.uniqDyn(dictMonadFRP)(Data_Eq.eqBoolean)(dyn))(function (dyn$prime) {
                    return dynamic_(dictMonadReplace)(dictMonadFRP)(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(dyn$prime)(function (value) {
                        return Control_Applicative.unless(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(value)(block);
                    }));
                });
            };
        };
    };
};
var whenD = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dyn) {
            return function (block) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.uniqDyn(dictMonadFRP)(Data_Eq.eqBoolean)(dyn))(function (dyn$prime) {
                    return dynamic_(dictMonadReplace)(dictMonadFRP)(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(dyn$prime)(function (value) {
                        return Control_Applicative.when(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(value)(block);
                    }));
                });
            };
        };
    };
};
var whenJustD = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dyn) {
            return function (widget) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.uniqDynBy(dictMonadFRP)(Data_Eq.eq(Data_Eq.eqBoolean))(Data_Functor.map(Specular_FRP_Base.functorDynamic)(Data_Maybe.isJust)(dyn)))(function (shouldDisplay) {
                    return whenD(dictMonadFRP)(dictMonadReplace)(shouldDisplay)(Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.readDynamic(dictMonadFRP.MonadEffect0())(dyn))(function (dynVal) {
                        if (dynVal instanceof Data_Maybe.Just) {
                            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newDynamic(dictMonadFRP.MonadEffect0())(dynVal.value0))(function (dyn$prime) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeEvent_(dictMonadFRP.MonadEffect0())(dictMonadFRP.MonadCleanup1())(dyn$prime.set)(Specular_FRP_Base.filterJustEvent(Specular_FRP_Base.changed(dyn))))(function () {
                                    return widget(dyn$prime.dynamic);
                                });
                            });
                        };
                        if (dynVal instanceof Data_Maybe.Nothing) {
                            return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(Data_Unit.unit);
                        };
                        throw new Error("Failed pattern match at Specular.FRP.Replaceable (line 40, column 5 - line 45, column 27): " + [ dynVal.constructor.name ]);
                    }));
                });
            };
        };
    };
};
var dynamic = function (dictMonadReplace) {
    return function (dictMonadFRP) {
        return function (dyn) {
            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (slot) {
                return Specular_FRP_Base.subscribeDyn(dictMonadFRP)(Control_Monad_Replace.replaceSlot(slot))(dyn);
            });
        };
    };
};
export {
    dynamic_,
    withDynamic_,
    dynamic,
    weakDynamic_,
    weakDynamic,
    whenJustD,
    whenD,
    unlessD
};
//# sourceMappingURL=index.js.map
